<template>
    <div class="co-importar-signatarios-tabela">
        <div class="busca mb-6">
            <div v-az-auth="'CadastroSignatario.Novo'" class="adicionar-signatario">
                <v-btn color="primary" dark depressed large @click="novoCadastroSignatario">
                    <v-icon size="20px" class="mr-2"> mdi-plus-circle </v-icon>
                    Adicionar
                </v-btn>
            </div>

            <div class="d-flex align-baseline barra-wrapper">
                <v-text-field
                    class="search-bar"
                    v-model="search"
                    label="Buscar pelo nome ou e-mail"
                    hide-details
                    @keyup.enter="atualizarFiltro">
                </v-text-field>

                <v-btn icon outlined @click="atualizarFiltro">
                    <v-icon dark>
                        mdi-magnify
                    </v-icon>
                </v-btn>
            </div>
        </div>

        <v-data-table
            v-model="value.selecionados"
            class="tabela-signatarios-importar-signatarios"
            hide-default-footer
            show-select
            :no-data-text="noDataText"
            :headers="headers"
            :items="cadastrosSignatarios"
            :items-per-page="5"
            checkbox-color="primary"
            @toggle-select-all="value.todosSelecionados = !value.todosSelecionados"
        >
            <template v-slot:header.data-table-select="{ props, on }">
                <v-simple-checkbox
                    :value="props.value || value.todosSelecionados || props.indeterminate"
                    v-on="on"
                    :indeterminate="props.indeterminate"
                    color="primary"
                />
            </template>

            <template v-slot:item.nome="{ item }">
                {{ (item.observador || !item.nome) ? 'N/A' : item.nome }}
            </template>

            <template v-slot:item.contato="{ item }">
                {{ montarContato(item) }}
            </template>
            <template v-slot:item.papel="{ item }">
                {{ item.observador ? 'N/A' : converterPapel(item.papelId) }}
            </template>

            <template v-slot:item.observador="{ item }">
                {{ item.observador ? 'Sim' : 'Não' }}
            </template>

        </v-data-table>

        <v-flex class="footer">
            <v-pagination
                dense
                class="paginas justify-center elevation-0"
                v-model="getPaginacaoAtual().page"
                :length="getPaginacaoAtual().numPages"
                :total-visible="7"
                @input="irParaPagina"/>
        </v-flex>
    </div>
</template>

<script>
import _ from 'lodash'
import {actionTypes, mutationTypes} from '@/commons/constants'
import {mapGetters, mapState} from 'vuex'

export default {
    name: 'ImportarSignatariosTabela',
    props: {
        value: {
            type: Object
        },
        papeisSignatario: {
            type: Array
        }
    },
    data() {
        return {
            listaSignatarios: [],
            cadastrosSignatarios: [],
            search: '',
            headers: [
                {
                    text: 'Nome',
                    align: 'left',
                    sortable: false,
                    filterable: true,
                    value: 'nome'
                },
                {
                    text: 'E-mail/Telefone',
                    align: 'left',
                    sortable: false,
                    filterable: true,
                    value: 'contato',
                    width: '35%'
                },
                {
                    text: 'Papel',
                    align: 'left',
                    sortable: false,
                    filterable: true,
                    value: 'papel',
                    width: '15%'
                },
                {
                    text: 'Observador',
                    align: 'left',
                    sortable: false,
                    filterable: false,
                    value: 'observador',
                    width: '15%'
                }
            ]
        }
    },
    async mounted() {
        await this.resetarPaginacao()
        await this.resetarFiltros()
        await this.buscarPagina()
    },
    computed: {
        ...mapState(['cadastrosSignatariosBusca']),
        ...mapGetters(['ehEfcazCLM']),
        noDataText() {
            return `Nenhum ${this.$tc("pt_br.signatario").toLowerCase()} encontrado.`
        }
    },
    methods: {
        atualizarListaCadastrosSignatarios(cadastrosSignatarios) {
            this.cadastrosSignatarios = cadastrosSignatarios
        },
        async atualizarFiltro() {
            await this.setFiltros({
                nome: {value: this.search, default: null},
            })
            await this.buscarPagina()
        },
        async buscarPagina() {
            const paginaCadastrosSignatarios = await this.$store.dispatch(actionTypes.CADASTRO_SIGNATARIOS.BUSCAR_CADASTROS_SIGNATARIOS_FILTRADOS)
            this.setPaginacao({
                numPages: paginaCadastrosSignatarios.totalPages
            })
            this.atualizarListaCadastrosSignatarios(paginaCadastrosSignatarios.content)
        },
        converterPapel(papelId) {
            try {
                return this.papeisSignatario.find(papel => papel.id === papelId).nome
            } catch (e) {
                return papelId
            }
        },
        getFiltrosAtuais() {
            return _.clone(this.cadastrosSignatariosBusca.filtros)
        },
        getPaginacaoAtual() {
            return _.clone(this.cadastrosSignatariosBusca.paginacao)
        },
        irParaPagina(pagina) {
            this.setPaginacao({
                page: pagina
            })
            this.buscarPagina()
        },
        montarContato(item) {
            if (item.tipoAssinatura === 'WHATSAPP') {
                let ddd = item.telefone.substring(0, 2);
                let telefone = item.telefone.substring(2);
                return '+' + item.ddi + " (" + ddd + ") " + telefone;
            } else {
                return item.email
            }
        },
        novoCadastroSignatario() {
            this.$emit('novo')
        },
        resetarPaginacao() {
            this.setPaginacao({
                page: 1,
                rowsPerPage: 5
            })
        },
        resetarFiltros() {
            this.setFiltros({
                nome: {value: null, default: null},
            })
        },
        setFiltros(filtros) {
            const filtrosAtuais = this.getFiltrosAtuais()
            this.$store.commit(mutationTypes.SET_FILTROS_CADASTROS_SIGNATARIOS, Object.assign({}, filtrosAtuais, filtros))
        },
        setPaginacao(paginacao) {
            const paginacaoAtual = this.getPaginacaoAtual()
            this.$store.commit(mutationTypes.SET_PAGINACAO_CADASTROS_SIGNATARIOS, Object.assign({}, paginacaoAtual, paginacao))
        }
    }
}
</script>

<style lang="stylus">
.co-importar-signatarios-tabela
    .busca
        justify-content end
        display flex
        align-items center

        .barra-wrapper
            width 100%
            justify-content end
            gap 10px

            .search-bar
                max-width 350px;

    .tabela-signatarios-importar-signatarios
        min-height 290px

    .v-data-table-header th
        background-color var(--divider-100) !important


@media (max-width: 600px)
    .co-importar-signatarios-tabela
        .tabela-signatarios-importar-signatarios
            .v-data-table__wrapper
                overflow-y auto
                height 55vh

                thead
                    tr
                        th
                            width 100vw

                table
                    display block
                    max-width 100%

                    tbody
                        display flex

                        tr
                            td
                                text-align left

                                .v-data-table__mobile-row__header
                                    flex 1

                                .v-data-table__mobile-row__cell
                                    overflow hidden
                                    text-overflow ellipsis
                                    max-width 55%
                                    text-align left
        .busca
            gap 15px
            flex-direction column
            align-items start !important

            .barra-wrapper
                .search-bar
                    max-width 100%
                    width 100%

@media (max-height: 740px)
    .co-importar-signatarios-tabela
        .tabela-signatarios-importar-signatarios
            .v-data-table__wrapper
                height 50vh

@media (max-height: 660px)
    .co-importar-signatarios-tabela
        .tabela-signatarios-importar-signatarios
            .v-data-table__wrapper
                    height 45vh
</style>
